import { useRef, useEffect, useState } from 'react';
import { useEventListeners, useOutsideClick } from 'src/hooks/utils';

export function useActionMenuBehavior() {
  const triggerRef = useRef<HTMLElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);
  const [menuVisible, setMenuVisible] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ top: 0, right: 0 });

  const handleResize = () => {
    const rect = triggerRef.current?.getBoundingClientRect();
    if (rect) {
      setMenuPosition({ top: rect.top, right: window.innerWidth - rect.left });
    }
  };

  useOutsideClick(menuRef, e => {
    if (!triggerRef.current?.contains(e.target as Node)) {
      setMenuVisible(false);
    }
  });

  useEffect(() => {
    const handleTouch = (e: TouchEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setMenuVisible(false);
      }
    };
    document.addEventListener('touchstart', handleTouch);
    return () => document.removeEventListener('touchstart', handleTouch);
  }, []);

  useEventListeners([{ event: 'resize' }, { event: 'wheel' }], () => {
    setMenuVisible(false);
    handleResize();
  });

  useEffect(() => {
    handleResize();
  }, [triggerRef.current]);

  return {
    triggerRef,
    menuRef,
    menuVisible,
    menuPosition,
    setMenuVisible,
    handleResize,
  };
}
